import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(VBreadcrumbs, {
        attrs: { items: _vm.items },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function (props) {
              return [
                _c(
                  VBreadcrumbsItem,
                  {
                    class: props.item.href ? "enabled" : "disabled",
                    attrs: { disabled: !props.item.href },
                    on: {
                      click: function ($event) {
                        return _vm.$router.push(props.item.href)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(props.item.text.toUpperCase()) + " ")]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }